import { isNativePlatform } from '../utils/platform';
import { configureStatusBar } from './statusBar';
import { configureBackButton } from './backButton';
import { configureKeyboard } from './keyboard';
import { setupExternalLinkInterceptor } from './externalLinks';
import { configureDeepLinks } from './deepLinks';
import { initializeVersionGate } from './versionGate';

export async function initializeCapacitor(): Promise<void> {
  if (!isNativePlatform()) return;

  // SplashScreen.hide() is called from SplashAnimation's useEffect — that
  // guarantees the overlay is mounted before the native splash dismisses.
  setupExternalLinkInterceptor();
  configureDeepLinks();
  await Promise.allSettled([
    configureStatusBar(),
    configureBackButton(),
    configureKeyboard(),
    initializeVersionGate(),
  ]);
}
